/* eslint-disable no-console */

import { register } from 'register-service-worker'

// 用于版本比较和更新检测的函数
let currentVersion = null;

async function checkForNewVersion() {
  try {
    // 添加时间戳参数，防止缓存
    const response = await fetch(`/version.json?t=${new Date().getTime()}`);
    if (!response.ok) {
      throw new Error('Failed to fetch version info');
    }
    const data = await response.json();
    
    // 第一次加载时保存版本信息
    if (!currentVersion) {
      currentVersion = data.version;
      console.log('Current version:', currentVersion);
      // 设置定期检查更新
      setInterval(checkForNewVersion, 60000); // 每分钟检查一次
      return;
    }
    
    // 检查是否有新版本
    if (data.version !== currentVersion) {
      console.log(`New version detected: ${currentVersion} -> ${data.version}`);
      // 触发更新事件（模拟Service Worker的updated事件）
      document.dispatchEvent(new CustomEvent('app-update-available', { detail: data }));
      currentVersion = data.version;
    }
  } catch (err) {
    console.error('Failed to check for updates:', err);
  }
}

// 初始化时调用一次检查函数
document.addEventListener('DOMContentLoaded', checkForNewVersion);

// 处理版本更新事件
document.addEventListener('app-update-available', (event) => {
  console.log('Update available event received', event.detail);
  // 显示更新提示
  showUpdateNotification();
});

// 显示更新通知的函数
function showUpdateNotification() {
  if (Object.prototype.hasOwnProperty.call(window, 'ELEMENT') && window.ELEMENT && window.ELEMENT.MessageBox) {
    window.ELEMENT.MessageBox.confirm(
      '发现新版本，是否立即刷新页面？',
      '更新提示', 
      {
        confirmButtonText: '立即刷新',
        cancelButtonText: '稍后刷新',
        type: 'info'
      }
    ).then(() => {
      // 用户确认刷新
      window.location.reload(true);
    }).catch(() => {
      // 用户取消刷新，不做操作
    });
  } else {
    // 备用方案：如果ELEMENT组件库不可用
    const refreshNotification = document.createElement('div');
    refreshNotification.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 20px;
      right: 20px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      padding: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 9999;
    `;
    
    refreshNotification.innerHTML = `
      <span style="font-size: 14px;">发现新版本可用，请刷新页面获取最新内容</span>
      <button style="background: #409EFF; color: white; border: none; padding: 6px 16px; border-radius: 4px; cursor: pointer;">立即刷新</button>
    `;
    
    document.body.appendChild(refreshNotification);
    
    refreshNotification.querySelector('button').addEventListener('click', () => {
      window.location.reload(true);
    });
  }
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      // 使用registration变量，避免未使用警告
      console.log('Registration scope:', registration.scope)
      // 通过Service Worker检测到更新时也调用我们的更新通知函数
      showUpdateNotification();
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
